import { BrandLoader } from '@/ui/Loader';
/**
 * Shared "waiting for a connection" screen for both root guards (fix round
 * 2, minor). Distinct from `GuardErrorScreen`: a paused fetch (TanStack
 * Query's `networkMode: 'online'` default pauses rather than fails a fetch
 * while offline) is not a server error — telling the visitor to "retry, or
 * sign out" as if something broke is misleading when the honest answer is
 * "you have no connection right now". This screen has no Retry button (the
 * query resumes automatically the moment the browser comes back online —
 * TanStack Query listens for that itself) and keeps Sign out only as an
 * escape hatch.
 */
export function GuardOfflineScreen({ onSignOut }: { onSignOut: () => Promise<void> }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-background p-lg">
      <div className="ng-reveal w-full max-w-[420px] rounded-card border border-border bg-surface p-xl text-center shadow-card">
        <BrandLoader size={48} className="mx-auto" />
        <p className="mt-md text-h2 font-extrabold text-ink">Waiting for a connection…</p>
        <p className="mt-xs text-body text-ink-2">
          You appear to be offline. This will continue automatically once you&apos;re back online.
        </p>
        <div className="mt-md">
          <button type="button" onClick={() => void onSignOut()} className="text-body font-semibold text-ink-2 hover:underline">
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
